<template>
  <Slide anchor="intro">
    <h1>
      Красиво. Просто.<br>
      Современно.
    </h1>
    <div class="description">
      <div class="line"></div>
      <span>
        Технологии идут в ногу со временем.<br>
        Прямо вслед за нами.
      </span>
    </div>
  </Slide>
</template>

<script>
  import Slide from './Slide';

  export default {
    name: 'Intro',
    components: { Slide },
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  #intro {
    min-width: calc(@slide-min-width - 60vh);

    @media @vertical {
      min-width: unset;
    }
  }

  .slide {
    flex-direction: column;
    justify-content: initial;

    .content {
      flex-direction: column;
    }
  }

  h1 {
    font-family: @font-sets[header];
    font-size: @font-sizes[header];
    margin: 0;

    @media @vertical {
      font-size: @font-sizes-v[header];
    }

    @media @mobile {
      font-size: @font-sizes-m[header];
    }

    @media @mobile-vertical {
      font-size: @font-sizes-mv[header];
    }
  }

  .description {
    display: flex;
    font-size: 3.25vh;
    line-height: 5vh;
    margin-top: 5vh;
    color: @colors[soft];

    @media @vertical {
      font-size: 2.5vw;
      line-height: 3vw;
      margin-top: 3vw;
    }

    @media @mobile {
      @margin: @font-sizes-m[normal] * 1.2;

      font-size: @font-sizes-m[normal];
      line-height: @margin;
      margin-top: @margin;
    }

    @media @mobile-vertical {
      @margin: @font-sizes-mv[normal] * 1.2;

      font-size: @font-sizes-mv[normal];
      line-height: @margin;
      margin-top: @margin;
      flex-direction: column;
      margin-top: 0;
    }
  }

  .line {
    width: 25vh;
    height: 0.5vh;
    background-color: @colors[soft];
    margin: 2vh 5vh 0 0.8vh;

    @media @vertical {
      width: 20vw;
      height: 0.25vw;
      margin: 1.25vw 5vw 0 0.8vw;
    }

    @media @mobile-vertical {
      width: 50vw;
      margin: 5vw 0;
      align-self: center;
      height: 0.4vw;
    }
  }
</style>

<style lang="less">
  #intro {
    .content {
      flex-direction: column;
    }
  }
</style>
